<template>
  <v-layout align-start class="pa-3">
    <v-icon class="mr-1">fad fa-comment-plus</v-icon>
    <v-btn text small v-if="!commenting" @click.native.stop="commenting = true" class="ma-0"> Add a comment</v-btn>
    <v-card flat width="100%" class="ml-2" v-if="commenting && !LoadingComments">
      <v-flex>
        <v-textarea v-model="comment" label="Add a comment" rows="3" filled></v-textarea>
      </v-flex>
      <v-flex v-if="canSetVisibility">
        <v-list two-line subheader dense>
          <v-subheader>Visibility - who do you want to see this comment?</v-subheader>
          <v-list-item @click="selectVisibility('platform')" :class="{ selected: visibility.platform === true }">
            <v-list-item-avatar>
              <img
                src="https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/logo.png"
                alt="Platform"
              />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Platform</v-list-item-title>
              <v-list-item-subtitle>Visible to Platform Users only</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon v-if="visibility.platform" color="success">fa-check</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-list-item @click="selectVisibility('referrer')" :class="{ selected: visibility.referrer === true }">
            <v-list-item-avatar color="secondary">
              <span class="white--text headline">{{ startsWith(referral.referrer.name) }}</span>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ referral.referrer.name }}</v-list-item-title>
              <v-list-item-subtitle>Visible to Platform Users and the Referring party only</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon v-if="visibility.referrer" color="success">fa-check</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-flex>
      <v-flex layout row xs12 justify-space-between>
        <v-btn :disabled="cannotPost" class="ml-3 mb-3 px-3" color="accent" text large @click="postComment">
          Post Comment <v-icon class="ml-2" large color="accent">send</v-icon>
        </v-btn>
        <v-btn class="px-3" text @click="commenting = false"
          >Cancel <v-icon class="ml-2">fa-comment-slash</v-icon></v-btn
        >
      </v-flex>
    </v-card>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'comment-form',
  props: ['referral'],
  components: {},
  data: () => ({
    comment: null,
    commenting: false,
    visibility: {
      platform: false,
      funders: false,
      funder: [],
      referrer: false
    }
  }),
  computed: {
    ...mapGetters(['UserHasRole', 'LoadingComments', 'StatusColours', 'FunderEnquiries']),
    canSetVisibility() {
      return this.UserHasRole('Platform');
    },
    cannotPost() {
      if (this.UserHasRole('Platform')) {
        return (
          _.isNull(this.comment) ||
          this.comment === '' ||
          (this.visibility.platform === false && this.visibility.referrer === false)
        );
      }
      return _.isNull(this.comment) || this.comment === '';
    }
  },
  methods: {
    ...mapActions(['postReferralComment']),
    startsWith: function(string) {
      return _.upperCase(string[0]);
    },
    selectVisibility: function(entity, id = '') {
      this.resetVisibility();
      if (entity === 'funder') {
        this.visibility[entity].push(id);
      } else {
        this.visibility[entity] = true;
      }
    },
    resetVisibility: function() {
      this.visibility = {
        platform: false,
        funders: false,
        funder: [],
        referrer: false
      };
    },
    enquirySelected: function(id) {
      return this.visibility.funder.indexOf(id) !== -1;
    },
    postComment() {
      const commentParams = {};

      if (this.UserHasRole('Call Centre')) {
        this.visibility.platform = true;
      }

      if (this.visibility.funders === true || this.visibility.platform === true) {
        _.merge(commentParams, { id: this.referral.id, type: 'business' });
      } else if (this.visibility.referrer === true) {
        _.merge(commentParams, { id: this.referral.referrer.id, type: 'referral' });
      } else {
        _.merge(commentParams, { id: this.visibility.funder[0], type: 'enquiry' });
      }

      this.postReferralComment({
        comment: this.comment,
        privacy: this.visibility.platform === true ? 'internal' : 'public',
        commentParams
      }).then(() => {
        this.comment = null;
        this.commenting = false;
      });
    },
    colour(enquiryStatus) {
      let status = _.find(this.StatusColours, ['status', enquiryStatus]);
      if (_.isUndefined(status)) {
        status = { colour: 'light-grey' };
      }
      return status.colour;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-avatar.light-grey {
  background-color: #f5f5f5;
}
</style>
